(() => {
  const moduleSelector = '[data-placement="bottomOfCart"][class*="NotesModule_NotesModule__"]';
  const toggleSelector = '[class*="NotesModule_NotesModule__dropdownContainer__"]';
  const fieldSelector = 'textarea, input:not([type="hidden"]), [contenteditable="true"]';

  function isVisible(element) {
    if (!element) return false;

    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.offsetParent !== null;
  }

  function isExpanded(moduleElement) {
    const expandedControl =
      moduleElement.querySelector('[aria-expanded]') || moduleElement.closest('[aria-expanded]');

    if (expandedControl) {
      return expandedControl.getAttribute('aria-expanded') === 'true';
    }

    const field = moduleElement.querySelector(fieldSelector);
    return isVisible(field);
  }

  function expandNotesModule(moduleElement) {
    if (!moduleElement || moduleElement.dataset.notesAutoExpanding === 'true') return;

    const toggle = moduleElement.querySelector(toggleSelector);
    if (!toggle) return;

    if (isExpanded(moduleElement)) return;

    moduleElement.dataset.notesAutoExpanding = 'true';

    window.requestAnimationFrame(() => {
      if (!isExpanded(moduleElement)) toggle.click();
      window.setTimeout(() => {
        delete moduleElement.dataset.notesAutoExpanding;
      }, 300);
    });
  }

  function scan(root = document) {
    if (!(root instanceof Element || root instanceof Document)) return;

    root.querySelectorAll(moduleSelector).forEach(expandNotesModule);
  }

  function startObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.target instanceof Element) {
          const moduleElement = mutation.target.closest(moduleSelector);
          if (moduleElement) expandNotesModule(moduleElement);
        }

        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          if (node.matches(moduleSelector)) {
            expandNotesModule(node);
            return;
          }

          if (node.querySelector(moduleSelector)) {
            scan(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-expanded', 'class', 'hidden', 'style'],
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      scan();
      startObserver();
    });
  } else {
    scan();
    startObserver();
  }
})();
